module.exports = __webpack_public_path__ + "img/live-cover.826fb068.jpg";